module.exports = __webpack_public_path__ + "media/theme/itunes__tutorial--7--a-aafbba1f.png";